const elderlyServiceRouter = {
  path: "/elderlyService", //主体
  name: "elderlyService",
  // redirect: "/orgBuild",
  component: () => import("../views/elderlyService/main"),
   redirect: "/serviceMange",
  children: [
    // {
    //   path: "/standardAddress",
    //   name: "standardAddress",
    //   mate: {
    //     title: "标准地址库"
    //   },
    //   component: () => import("../views/elderlyService/standardAddress/index")
    // },
    {
      path: "/serviceMange",
      name: "serviceMange",
      mate:                                                                                                                                                                                     {
        title: "服务站管理"
      },
      component: () => import("../views/elderlyService/serviceMange/index")
    },
    {
      path: "/joinMange",
      name: "joinMange",
      mate: {
        title: "加盟店管理"
      },
      component: () => import("../views/elderlyService/joinMange/index")
    },
    {
      path: "/facilitator",
      name: "facilitator",
      mate: {
        title: "服务商管理"
      },
      component: () => import("../views/elderlyService/facilitator/index")
    },
    {
      path: "/serviceCapital",
      name: "serviceCapital",
      mate: {
        title: "服务资金库"
      },
      component: () => import("../views/elderlyService/serviceCapital/index")
    },
    {
      path: "/divisionalManage",
      name: "divisionalManage",
      mate: {
        title: "部门管理"
      },
      component: () =>
        import("../views/elderlyService/dataDictionary/divisionalManage.vue")
    },
    {
      path: "/personnelType1",
      name: "personnelType1",
      mate: {
        title: "人员类型"
      },
      component: () =>
        import("../views/elderlyService/dataDictionary/personnelType.vue")
    },
    {
      path: "/serviceObject1",
      name: "serviceObject1",
      mate: {
        title: "老人类别"
      },
      component: () =>
        import("../views/elderlyService/dataDictionary/serviceObject.vue")
    },
    {
      path: "/positionManage",
      name: "positionManage",
      mate: {
        title: "职位管理"
      },
      component: () =>
        import("../views/elderlyService/dataDictionary/position.vue")
    },
    {
      path: "/benefitOld",
      name: "benefitOld",
      mate: {
        title: "惠老政策"
      },
      component: () =>
        import("../views/elderlyService/benefitMange/benefitOld/index")
    },
    {
      path: "/newsInfo",
      name: "newsInfo",
      mate: {
        title: "新闻资讯"
      },
      component: () =>
        import("../views/elderlyService/benefitMange/newsInfo/index")
    },
    {
      path: "/notices",
      name: "notices",
      mate: {
        title: "通知公告"
      },
      component: () =>
        import("../views/elderlyService/benefitMange/notices/index")
    },
    {
      path: "/businessGuide",
      name: "businessGuide",
      mate: {
        title: "办事指南"
      },
      component: () =>
        import("../views/elderlyService/benefitMange/businessGuide/index")
    },
    {
      path: "/homeMange",
      name: "homeMange",
      mate: {
        title: "居家养老管理"
      },
      component: () =>
        import("../views/elderlyService/resource/homeMange/index")
    },
    {
      path: "/productManages", //产品管理
      name: "productManages",
      component: () =>
        import("../views/elderlyService/resource/productManage/index"),
      mate: {
        title: "产品管理"
      }
    },
    {
      path: "/monitors", //产品管理
      name: "monitors",
      component: () =>
        import("../views/elderlyService/resource/monitors/index"),
      mate: {
        title: "监控管理"
      }
    },
    {
      path: "/mechanismMange",
      name: "mechanismMange",
      mate: {
        title: "机构养老管理"
      },
      component: () =>
        import("../views/elderlyService/resource/mechanismMange/index")
    },
    {
      path: "/communityMange",
      name: "communityMange",
      mate: {
        title: "社区养老管理"
      },
      component: () =>
        import("../views/elderlyService/resource/communityMange/index")
    },
    {
      path: "/olderMange",
      name: "olderMange",
      mate: {
        title: "老人管理"
      },
      component: () =>
        import("../views/elderlyService/resource/olderMange/index")
    },
    {
      path: "/servicePerson",
      name: "servicePerson",
      mate: {
        title: "服务人员"
      },
      component: () =>
        import("../views/elderlyService/resource/servicePerson/index")
    },
    {
      path: "/assessmentReports",
      name: "assessmentReports",
      mate: {
        title: "评估报告"
      },
      component: () =>
        import("../views/elderlyService/resource/assessmentReports/index")
    },
    {
      path: "/addressMange",
      name: "addressMange",
      mate: {
        title: "地址管理"
      },
      component: () =>
        import("../views/elderlyService/resource/addressMange/index")
    },
    {
      path: "/knowledgeMange",
      name: "knowledgeMange",
      mate: {
        title: "知识库管理"
      },
      component: () =>
        import("../views/elderlyService/resource/knowledge/knowledgeMange/index")
    },
    {
      path: "/businessInfo",
      name: "businessInfo",
      mate: {
        title: "业务资料库"
      },
      component: () =>
        import("../views/elderlyService/resource/knowledge/businessInfo/index")
    },
    {
      path: "/businessTypes",
      name: "businessTypes",
      mate: {
        title: "业务资料库类别"
      },
      component: () =>
        import("../views/elderlyService/resource/knowledge/businessTypes/index")
    },
    {
      path: "/questionLibrary",
      name: "questionLibrary",
      mate: {
        title: "问题库"
      },
      component: () =>
        import("../views/elderlyService/resource/knowledge/questionLibrary/index")
    },
    {
      path: "/labourUnion",
      name: "labourUnion",
      mate: {
        title: "工会组织"
      },
      component: () =>
        import("../views/elderlyService/resource/organization/labourUnion/index")
    },
    {
      path: "/chamberCommerce",
      name: "chamberCommerce",
      mate: {
        title: "商会组织"
      },
      component: () =>
        import("../views/elderlyService/resource/organization/chamberCommerce/index")
    },
    {
      path: "/socialWorker",
      name: "socialWorker",
      mate: {
        title: "社工组织"
      },
      component: () =>
        import("../views/elderlyService/resource/organization/socialWorker/index")
    },
    {
      path: "/houseLogin",
      name: "houseLogin",
      mate: {
        title: "房屋信息登录"
      },
      component: () =>
        import("../views/elderlyService/resource/house/houseLogin/index")
    },
    {
      path: "/houseRent",
      name: "houseRent",
      mate: {
        title: "承租信息登记表"
      },
      component: () =>
        import("../views/elderlyService/resource/house/houseRent/index")
    },
    {
      path: "/publicSafe",
      name: "publicSafe",
      mate: {
        title: "公共安全"
      },
      component: () =>
        import("../views/elderlyService/resource/land/publicSafe/index")
    },
    {
      path: "/marketSupervision",
      name: "marketSupervision",
      mate: {
        title: "市场监管"
      },
      component: () =>
        import("../views/elderlyService/resource/land/marketSupervision/index")
    },
    {
      path: "/serviceMen",
      name: "serviceMen",
      mate: {
        title: "为民服务"
      },
      component: () =>
        import("../views/elderlyService/resource/land/serviceMen/index")
    },
    {
      path: "/guaranteeMen",
      name: "guaranteeMen",
      mate: {
        title: "民生保障"
      },
      component: () =>
        import("../views/elderlyService/resource/land/guaranteeMen/index")
    },
    {
      path: "/multiMediation",
      name: "multiMediation",
      mate: {
        title: "多元调解"
      },
      component: () =>
        import("../views/elderlyService/resource/land/multiMediation/index")
    },
    {
      path: "/marketCompany",
      name: "marketCompany",
      mate: {
        title: "市场企业"
      },
      component: () =>
        import("../views/elderlyService/resource/land/marketCompany/index")
    },
    {
      path: "/estateMange",
      name: "estateMange",
      mate: {
        title: "物业管理人员"
      },
      component: () =>
        import("../views/elderlyService/resource/land/team/estateMange/index")
    },
    {
      path: "/lawyer",
      name: "lawyer",
      mate: {
        title: "律师"
      },
      component: () =>
        import("../views/elderlyService/resource/land/team/lawyer/index")
    },
    {
      path: "/communityPolice",
      name: "communityPolice",
      mate: {
        title: "社区民警"
      },
      component: () =>
        import("../views/elderlyService/resource/land/team/communityPolice/index")
    },
    {
      path: "/hospital",
      name: "hospital",
      mate: {
        title: "医院"
      },
      component: () =>
        import("../views/elderlyService/resource/land/hygiene/hospital/index")
    },
    {
      path: "/pharmacy",
      name: "pharmacy",
      mate: {
        title: "药店"
      },
      component: () =>
        import("../views/elderlyService/resource/land/hygiene/pharmacy/index")
    },
    {
      path: "/clinic",
      name: "clinic",
      mate: {
        title: "诊所"
      },
      component: () =>
        import("../views/elderlyService/resource/land/hygiene/clinic/index")
    },
    {
      path: "/trainingInstitutions",
      name: "trainingInstitutions",
      mate: {
        title: "培训机构"
      },
      component: () =>
        import("../views/elderlyService/resource/land/education/trainingInstitutions/index")
    },
    {
      path: "/kindergarten",
      name: "kindergarten",
      mate: {
        title: "幼儿园"
      },
      component: () =>
        import("../views/elderlyService/resource/land/education/kindergarten/index")
    },
    {
      path: "/school",
      name: "school",
      mate: {
        title: "学校"
      },
      component: () =>
        import("../views/elderlyService/resource/land/education/school/index")
    },
    {
      path: "/realPopulation",
      name: "realPopulation",
      mate: {
        title: "实有人口"
      },
      component: () =>
        import("../views/elderlyService/resource/men/realPopulation/index")
    },
    {
      path: "/objectCare",
      name: "objectCare",
      mate: {
        title: "关怀对象"
      },
      component: () =>
        import("../views/elderlyService/resource/men/objectCare/index")
    },
    {
      path: "/epidemicPopulation",
      name: "epidemicPopulation",
      mate: {
        title: "疫情人口"
      },
      component: () =>
        import("../views/elderlyService/resource/men/epidemicPopulation/index")
    },
    {
      path: "/communityCorrection",
      name: "communityCorrection",
      mate: {
        title: "社区矫正人员"
      },
      component: () =>
        import("../views/elderlyService/resource/men/special/communityCorrection/index")
    },
    {
      path: "/keyPetition",
      name: "keyPetition",
      mate: {
        title: "重点上访"
      },
      component: () =>
        import("../views/elderlyService/resource/men/special/keyPetition/index")
    },
    {
      path: "/helpSettle",
      name: "helpSettle",
      mate: {
        title: "安置帮教"
      },
      component: () =>
        import("../views/elderlyService/resource/men/special/helpSettle/index")
    },
    {
      path: "/releasePrison",
      name: "releasePrison",
      mate: {
        title: "刑满释放人员"
      },
      component: () =>
        import("../views/elderlyService/resource/men/special/releasePrison/index")
    },
    {
      path: "/disciplineHealth",
      name: "disciplineHealth",
      mate: {
        title: "社戒社康人员"
      },
      component: () =>
        import("../views/elderlyService/resource/men/special/disciplineHealth/index")
    },
    {
      path: "/troubleOther",
      name: "troubleOther",
      mate: {
        title: "肇事肇祸等严重精神障碍患者"
      },
      component: () =>
        import("../views/elderlyService/resource/men/special/troubleOther/index")
    },
    {
      path: "/managementPart",
      name: "managementPart",
      mate: {
        title: "党员管理"
      },
      component: () =>
        import("../views/elderlyService/partyBuilding/managementPart/index")
    },
    {
      path: "/organizationalLife",
      name: "organizationalLife",
      mate: {
        title: "组织生活"
      },
      component: () =>
        import("../views/elderlyService/partyBuilding/organizationalLife/index")
    },
    {
      path: "/studyPart",
      name: "studyPart",
      mate: {
        title: "党员学习"
      },
      component: () =>
        import("../views/elderlyService/partyBuilding/studyPart/index")
    },
    {
      path: "/workPlan",
      name: "workPlan",
      mate: {
        title: "工作计划"
      },
      component: () =>
        import("../views/elderlyService/partyBuilding/workPlan/index")
    },
    {
      path: "/positionConstruction",
      name: "positionConstruction",
      mate: {
        title: "阵地建设"
      },
      component: () =>
        import("../views/elderlyService/partyBuilding/organization/positionConstruction/index")
    },
    {
      path: "/increasedOrganization",
      name: "increasedOrganization",
      mate: {
        title: "组织增加"
      },
      component: () =>
        import("../views/elderlyService/partyBuilding/organization/increasedOrganization/index")
    },
    {
      path: "/branchWork",
      name: "branchWork",
      mate: {
        title: "支部工作"
      },
      component: () =>
        import("../views/elderlyService/partyBuilding/organization/branchWork/index")
    },
    {
      path: "/publicOpinion",
      name: "publicOpinion",
      mate: {
        title: "社情民意收集"
      },
      component: () =>
        import("../views/elderlyService/social/publicOpinion/index")
    },
    {
      path: "/wasteStation",
      name: "wasteStation",
      mate: {
        title: "废品站"
      },
      component: () =>
        import("../views/elderlyService/resource/land/marketSupervision/WasteStation/index.vue")
    },
    {
      path: "/supermarketConvenience",
      name: "supermarketConvenience",
      mate: {
        title: "超市 便利店"
      },
      component: () =>
        import("../views/elderlyService/resource/land/marketSupervision/supermarketConvenience/index.vue")
    },
    {
      path: "/foodMarket",
      name: "foodMarket",
      mate: {
        title: "菜市场"
      },
      component: () =>
        import("../views/elderlyService/resource/land/marketSupervision/foodMarket/index.vue")
    },
    {
      path: "/bank",
      name: "bank",
      mate: {
        title: "银行"
      },
      component: () =>
        import("../views/elderlyService/resource/land/marketSupervision/bank/index.vue")
    },
    {
      path: "/gasStation",
      name: "gasStation",
      mate: {
        title: "加油站"
      },
      component: () =>
        import("../views/elderlyService/resource/land/marketSupervision/gasStation/index.vue")
    },
    {
      path: "/policeStation",
      name: "policeStation",
      mate: {
        title: "派出所"
      },
      component: () =>
        import("../views/elderlyService/resource/land/publicSafe/policeStation/index.vue")
    },
    {
      path: "/policeRoom",
      name: "policeRoom",
      mate: {
        title: "警务室"
      },
      component: () =>
        import("../views/elderlyService/resource/land/publicSafe/policeRoom/index.vue")
    },
    {
      path: "/redProperty",
      name: "redProperty",
      mate: {
        title: "红色物业"
      },
      component: () =>
        import("../views/elderlyService/resource/land/serviceMen/redProperty/index.vue")
    },
    {
      path: "/residentsCouncil",
      name: "residentsCouncil",
      mate: {
        title: "居民议事会"
      },
      component: () =>
        import("../views/elderlyService/resource/land/serviceMen/residentsCouncil/index.vue")
    },
    {
      path: "/partyMassMeeting",
      name: "partyMassMeeting",
      mate: {
        title: "党群议事会"
      },
      component: () =>
        import("../views/elderlyService/resource/land/serviceMen/partyMassMeeting/index.vue")
    },
    {
      path: "/PartyMassActivityAenter",
      name: "PartyMassActivityAenter",
      mate: {
        title: "党群活动中心"
      },
      component: () =>
        import("../views/elderlyService/resource/land/serviceMen/PartyMassActivityAenter/index.vue")
    },
    {
      path: "/enterpriseProperty",
      name: "enterpriseProperty",
      mate: {
        title: "企业型物业"
      },
      component: () =>
        import("../views/elderlyService/resource/land/serviceMen/enterpriseProperty/index.vue")
    },
    {
      path: "/judicialOffice",
      name: "judicialOffice",
      mate: {
        title: "法律服务所"
      },
      component: () =>
        import("../views/elderlyService/resource/land/multiMediation/judicialOffice/index.vue")
    },
    {
      path: "/LawOffices",
      name: "LawOffices",
      mate: {
        title: "司法所"
      },
      component: () =>
        import("../views/elderlyService/resource/land/multiMediation/LawOffice/index.vue")
    },
    {
      path: "/MediationCommittee",
      name: "MediationCommittee",
      mate: {
        title: "调解委员会"
      },
      component: () =>
        import("../views/elderlyService/resource/land/multiMediation/MediationCommittee/index.vue")
    },
    {
      path: "/MarketEnterprises",
      name: "MarketEnterprises",
      mate: {
        title: "市场企业"
      },
      component: () =>
        import("../views/elderlyService/resource/land/marketCompany/MarketEnterprises/index.vue")
    },
    {
      path: "/AlongTheStreetFront",
      name: "AlongTheStreetFront",
      mate: {
        title: "沿街门面"
      },
      component: () =>
        import("../views/elderlyService/resource/land/marketCompany/AlongTheStreetFront/index.vue")
    },
    {
      path: "/BuildingEnterprises",
      name: "BuildingEnterprises",
      mate: {
        title: "楼宇企业"
      },
      component: () =>
        import("../views/elderlyService/resource/land/marketCompany/BuildingEnterprises/index.vue")
    },
    {
      path: "/floatingPopulation",
      name: "floatingPopulation",
      mate: {
        title: "流动人口"
      },
      component: () =>
        import("../views/elderlyService/resource/men/realPopulation/floatingPopulation/index.vue")
    },
    {
      path: "/BasicInformationOfPopulation",
      name: "BasicInformationOfPopulation",
      mate: {
        title: "人口基础信息表"
      },
      component: () =>
        import("../views/elderlyService/resource/men/realPopulation/BasicInformationOfPopulation/index.vue")
    },
    {
      path: "/PopulationStatistics",
      name: "PopulationStatistics",
      mate: {
        title: "人口统计"
      },
      component: () =>
        import("../views/elderlyService/resource/men/realPopulation/PopulationStatistics/index.vue")
    },

    {
      path: "/theElderlys",
      name: "theElderlys",
      mate: {
        title: "80岁以上老人"
      },
      component: () =>
        import("../views/elderlyService/resource/men/objectCare/theElderly/index.vue")
    },
    {
      path: "/Disabled",
      name: "Disabled",
      mate: {
        title: "残疾人"
      },
      component: () =>
        import("../views/elderlyService/resource/men/objectCare/Disabled/index.vue")
    },
    {
      path: "/EmptyNester",
      name: "EmptyNester",
      mate: {
        title: "空巢老人"
      },
      component: () =>
        import("../views/elderlyService/resource/men/objectCare/EmptyNester/index.vue")
    },
    {
      path: "/FamilyPlanningPersonnel",
      name: "FamilyPlanningPersonnel",
      mate: {
        title: "计生人员"
      },
      component: () =>
        import("../views/elderlyService/resource/men/objectCare/FamilyPlanningPersonnel/index.vue")
    },
    {
      path: "/PregnantWomen",
      name: "PregnantWomen",
      mate: {
        title: "孕优对象"
      },
      component: () =>
        import("../views/elderlyService/resource/men/objectCare/PregnantWomen/index.vue")
    },
    {
      path: "/leftbehindChildren",
      name: "leftbehindChildren",
      mate: {
        title: "留守儿童"
      },
      component: () =>
        import("../views/elderlyService/resource/men/objectCare/leftbehindChildren/index.vue")
    },
    {
      path: "/onelyOldPeople",
      name: "lonelyOldPeople",
      mate: {
        title: "孤寡老人(70岁以上)"
      },
      component: () =>
        import("../views/elderlyService/resource/men/objectCare/lonelyOldPeople/index.vue")
    },
    {
      path: "/DoubleSupportObject",
      name: "DoubleSupportObject",
      mate: {
        title: "双拥对象"
      },
      component: () =>
        import("../views/elderlyService/resource/men/objectCare/DoubleSupportObject/index.vue")
    }
  ]
}

export default elderlyServiceRouter
